import React, { useEffect, useState, useRef } from "react"
import {
  Row,
  Col,
  UncontrolledTooltip,
  Input,
  Label,
  Table,
  Button,
  Spinner,
  // Nav,
} from "reactstrap"
import { connect, useSelector, useDispatch } from "react-redux"
import Modal from "react-bootstrap/Modal"
import PropTypes from "prop-types"
import { withRouter, useParams, useHistory } from "react-router-dom"
// import { IoAttachOutline } from "react-icons/io5"
// import { RiCheckboxCircleLine } from "react-icons/ri"
import Select from "react-select"
import { get, isEmpty, isNaN } from "lodash"
import SimpleReactValidator from "simple-react-validator"
import moment from "moment"
import * as clientAction from "../../store/Y2xpZW50/actions"
import * as eventAction from "../../store/zXZlbnQq/actions"
import * as quotationAction from "../../store/cXVvdGF0/actions"
import * as salesAction from "../../store/c2FsZXMgZW5/actions"
// import * as followupAction from "../../store/Zm9sbG93dXA/actions"
import * as alterQuoteAction from "../../store/YWx0ZXIgcXVvdGU/actions"
import { style } from "./Input-Select/select"
import { toast } from "react-toastify"
import api from "../../helpers/Api"

const Sales = (props) => {
  const { dispatch, clientProfile, clientId, location } = props

  console.log(props, clientProfile, "props from api")

  let { id } = useParams()
  const specificDispatch = useDispatch()

  // CLientId, company and porcess status from getLeadByclient api
  const leadClientId = !isEmpty(clientId)
    ? clientId
    : location && location.state && location.state.row
      ? location.state.row.clientId
      : []

  const companyName =
    !isEmpty(clientProfile) && clientProfile ? clientProfile[0].company : ""
  const alterProcessStatus =
    !isEmpty(clientProfile) && clientProfile
      ? clientProfile[0].processStatus
      : []
  /// Client details values section end
  console.log(leadClientId, "location update")
  console.log(companyName, "companyNameDetails update")
  //Validator
  const simpleValidator = useRef(new SimpleReactValidator())
  const [forceUpdate, setForceUpdate] = useState(false)

  const history = useHistory()
  console.log(alterProcessStatus, "alterProcessStatus")
  // const editList =
  //   !isEmpty(sales_list) && sales_list === [] ? !salesList : salesList

  useEffect(() => {
    dispatch(clientAction.loadRecordClientDetails(id))
    dispatch(eventAction.loadRecordEventDetails(id))
    dispatch(quotationAction.loadServiceTotal(id))
    dispatch(salesAction.loadSalesList(id))
    dispatch(salesAction.loadSalesTempList(id))
    dispatch(salesAction.loadBankDetails(id))
    dispatch(salesAction.loadRecordsMetaData())
  }, [])

  const salesListApi = useSelector((specificState) => specificState.salesEntry)
  const {
    salesMetaData = {},
    sales_list = [],
    sales_payment_list = [],
    bank_details = [],
  } = salesListApi

  const [salesList, setSalesList] = useState(false)
  const [pageLoad, setPageLoad] = useState(false)

  const session = useSelector((specificState) => specificState.session)
  const clientListApi = useSelector((specificState) => specificState.client)
  const eventListApi = useSelector((specificState) => specificState.Event)
  const quotationListApi = useSelector(
    (specificState) => specificState.quotation
  )

  const { user = [] } = session

  const salesManagerId = !isEmpty(user) && user.roleId

  console.log(salesManagerId, "salesManagerId")

  const { record_client_details = [] } = clientListApi
  const { record_event_details = [] } = eventListApi
  const { service_total_account = [] } = quotationListApi

  const salesExecutive = !isEmpty(user) && user.name

  const clientData = get(record_client_details[0], "clientDetails", "")

  const eventArrayDetails = get(record_event_details[0], "events", "")

  const quotationData = !isEmpty(service_total_account) && service_total_account

  const quotationDate = moment(quotationData.leadQuotationDate).format(
    "YYYY-MM-DD"
  )

  const eventData =
    !isEmpty(eventArrayDetails) && eventArrayDetails.length > 0
      ? eventArrayDetails.filter((data) => data.status == 1)
      : []

  console.log(eventData, "eventData")

  //Modal For alter sales
  const [qcRemarks, setQcRemarks] = useState("")
  const [qcRequestLoading, setQcRequestLoading] = useState(false)
  const [alterSales, setAlterSales] = useState(false)
  const [requestModal, setRequestModal] = useState(false)
  const handleRequestClose = () => setRequestModal(false)

  //Alter quotes
  const [alterQcRemarks, setAlterQcRemarks] = useState("")
  const [alterQuote, setAlterQuote] = useState(false)
  const [alterQuoteModal, setAlterQuoteModal] = useState(false)
  const handleAlterQuoteClose = () => setAlterQuoteModal(false)

  //Sales Service confirmation

  // const [salesServiceModal, setSalesServiceModal] = useState(false)
  // const handleSalesServiceModal = () => setSalesServiceModal(false)

  const handleSalesServicePreview = () => {
    var leadNoValue = quotationData.leadNo + "_" + companyName
    let bufferObj = Buffer.from(leadNoValue, "utf8")
    let base64String = bufferObj.toString("base64")

    console.log(base64String, "base64String")
    console.log(bufferObj, "bufferObj")
    console.log(leadNoValue, "leadNoValue")
    if (companyName == "PHOTOGRAPHY") {
      const path =
        "https://alphamail.in/lo/sc" + "?type=" + id + "&&key=" + base64String
      window.open(path)
    } else if (companyName == "KNOT STORIES") {
      // https://alphamail.in/lo/ktsc?type=65cd9b74e606a8054b61e6d4&&key=WkdQTDAyMjQyOTYxX1BIT1RPR1JBUEhZ
      const path =
        "https://alphamail.in/lo/ktsc" + "?type=" + id + "&&key=" + base64String
      window.open(path)
    } else {
      const path =
        "https://alphamail.in/lo/sc" + "?type=" + id + "&&key=" + base64String
      window.open(path)
    }
  }

  const quotationId =
    !isEmpty(service_total_account) && service_total_account.leadQuotationId
  const leadId = id
  const leadQuotationId = !isEmpty(sales_list) && sales_list.quotationdId
  const salesId = !isEmpty(sales_list) && sales_list._id
  const remarks = qcRemarks

  const handleApproval = (success) => {
    specificDispatch(
      salesAction.approvalSalesRequestQc(
        leadId,
        leadQuotationId,
        salesId,
        remarks,
        success
      )
    )
    setQcRequestLoading(true)
    setTimeout(() => {
      setAlterSales(true)
      setQcRequestLoading(false)
    }, 2000)
  }
  console.log(history)

  //Alter quote functionality
  const handleAlterQuote = () => {
    const alterQuote = {
      leadId: id,
      leadQuotationId: quotationId,
      alterRemarks: alterQcRemarks,
    }
    specificDispatch(alterQuoteAction.alterQuoteRequest(alterQuote))
    setQcRequestLoading(true)
    setTimeout(() => {
      setAlterQuote(true)
      setQcRequestLoading(false)
      dispatch(
        clientAction.loadRecordClientProfileById({ clientId: leadClientId })
      )
      // history.push(`/client-details/${id}`)
    }, 2000)
  }
  console.log(alterQuote, "alterQuote")

  //Sales formData list

  const [isLoading, setIsLoading] = useState(false)
  const [updateStatus, setUpdateStatus] = useState(false)

  const [salesData, setSalesData] = useState({
    quotationNo: "",
    quotationDate: "",
    salesExecutive: "",
    billingName: "",
    gstNo: "",
    billingAddress: "",
    billingAddress_1: "",
    accountantNotes: "",
  })

  const handleChange = (e) => {
    setSalesData({ ...salesData, [e.target.name]: e.target.value })
  }

  //Event details section
  const [eventList, setEventList] = useState({
    travel: "",
    food: "",
    eventDate: "",
    eventName: "",
  })
  const [travel, setTravel] = useState([])
  const [food, setFood] = useState([])
  const [eventId, setEventId] = useState("")

  const [eventUpdate, setEventUpdate] = useState(false)

  console.log(travel, food, "travel and food")
  const editEventDetails = (events) => {
    const eventDate = !isEmpty(events.eventDate)
      ? moment(events.eventDate).format("DD/MM/YYYY")
      : "--"
    const eventName = !isEmpty(events.eventName) ? events.eventName : "--"
    setTravel({ label: events.travelStay, value: events.travelStay })
    setFood({ label: events.food, value: events.food })
    setEventList({
      ...eventList,
      travel: [{ label: events.travelStay, value: events.travelStay }],
      food: [{ label: events.food, value: events.food }],
      eventDate: eventDate,
      eventName: eventName,
    })

    setEventUpdate(true)
  }

  const [eventDetailsData, setEventDetailsData] = useState("")
  // const [eventArrayId, setEventArrayId] = useState("")
  useEffect(() => {
    if (eventArrayDetails.length > 0) {
      const foodDetailsData =
        !isEmpty(eventData) && eventData.length > 0
          ? eventData.map((data) => {
            if (!isEmpty(data.food)) {
              return {
                label: data.food,
                value: data.food,
              }
            }
          })
          : []
      const eventDetailsData =
        !isEmpty(eventData) && eventData.length > 0
          ? eventData.map((data) => {
            if (!isEmpty(data.food) && !isEmpty(data.travelStay)) {
              return {
                label: data.food,
                value: data.food,
              }
            }
          })
          : []

      const eventDetailsList =
        !isEmpty(eventDetailsData) && eventDetailsData.length > 0
          ? eventDetailsData.filter((data) => data == undefined)
          : []
      console.log(eventDetailsList, "eventDetailsList")
      setEventDetailsData(eventDetailsList)
      const foodDetails =
        !isEmpty(foodDetailsData) && foodDetailsData.length > 0
          ? foodDetailsData.filter((data) => data != undefined)
          : []
      const travelDetailsData =
        !isEmpty(eventData) && eventData.length > 0
          ? eventData.map((data) => {
            if (!isEmpty(data.travelStay)) {
              return {
                label: data.travelStay,
                value: data.travelStay,
              }
            }
          })
          : []
      const travelDetails =
        !isEmpty(travelDetailsData) && travelDetailsData.length > 0
          ? travelDetailsData.filter((data) => data != undefined)
          : []
      console.log(foodDetails, "foodDetails")
      console.log(foodDetailsData, "foodDetailsData")
      console.log(eventDetailsData, "eventDetailsData")
      console.log(travelDetailsData, "travelDetailsData")
      console.log(travelDetails, "travelDetails")
      setFood(foodDetails)
      setTravel(travelDetails)
    } else {
      setFood([])
      setTravel([])
    }
  }, [eventArrayDetails])

  const [inputErrors, setInputErrors] = useState(false)
  const updateEventDetails = (e) => {
    e.preventDefault()
    if (!isEmpty(food.value) && !isEmpty(travel.value)) {
      const eventUpdate = {
        leadId: id,
        leadEventDetail: [
          {
            leadEventId: eventId,
            travelStay: travel.label,
            food: food.label,
          },
        ],
      }
      setInputErrors(false)
      specificDispatch(salesAction.updateEventRecord(eventUpdate))
      setTimeout(() => {
        dispatch(eventAction.loadRecordEventDetails(id))
        // toast.success("Event details updated successfully")
        setEventUpdate(false)
      }, 2000)
    } else {
      // simpleValidator.current.showMessages()
      // forceUpdate(1)
      setInputErrors(true)
      setEventUpdate(true)
    }
  }

  // Payment Value section
  const [gstSelected, setGstSelected] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isSalesEdit, setIsSalesEdit] = useState(false)
  // const [paymentEdit, setPaymentEdit] = useState(false)

  const [paymentSet, setPaymentSet] = useState(false)
  const [paymentId, setPaymentId] = useState("")
  const [updatePayment, setUpdatePayment] = useState(false)
  const [gstPercentage, setGstPercentage] = useState([])
  const [taxModal, setTaxModal] = useState(false)
  const handleTaxClose = () => setTaxModal(false)

  const [paymentData, setPaymentData] = useState({
    amount: "",
    gst: "",
  })

  const paymentValueChange = (e) => {
    setPaymentData({
      ...paymentData,
      [e.target.name]: e.target.value,
    })
  }
  //Add more payment terms
  const addPaymentValue = () => {
    setPaymentData({
      amount: "",
      gst: "",
    })
    setGstPercentage([])
    setPaymentSet(true)
    // setIsEdit(false)
    setUpdatePayment(false)
  }

  //GST calculations
  const gstAmount = (paymentData.amount * gstPercentage.igst) / 100

  const amountGst = gstSelected ? gstAmount : 0

  const totalGst = parseInt(paymentData.amount) + parseInt(gstAmount)

  const totalGstAmount = gstSelected ? totalGst : 0

  //Add payment value

  const handlePaymentValue = () => {
    if (simpleValidator.current.allValid()) {
      const payments = {
        leadId: id,
        quotationdId: quotationData.leadQuotationId,
        mode: "tax",
        data: {
          taxableValue: parseFloat(paymentData.amount),
          taxPercentage: gstPercentage.label,
          taxPercentageId: gstPercentage.value,
          taxAmount: amountGst,
          totalValue: totalGstAmount,
        },
      }
      specificDispatch(salesAction.createSalesTempRecord(payments))
      setTimeout(() => {
        specificDispatch(salesAction.loadSalesTempList(id))
        setPaymentSet(false)
        // setValueTotal(true)
      }, 2000)
    } else {
      simpleValidator.current.showMessages()
      setForceUpdate(true)
      setPaymentSet(true)
      console.log(forceUpdate)
      return false
    }
    // setFormData([payments])
  }

  const paymentList =
    !isEmpty(sales_payment_list) &&
    sales_payment_list.map((payment) => {
      if (payment.mode === "tax") {
        return {
          _id: payment._id,
          leadId: payment.leadId,
          quotationId: payment.quotationdId,
          taxId: payment.data._id,
          taxableValue: payment.data.taxableValue,
          taxPercentage: payment.data.taxPercentage,
          taxPercentageId: payment.data.taxPercentageId,
          taxAmount: payment.data.taxAmount,
          totalValue: payment.data.totalValue,
        }
      }
    })

  // const withoutTaxAmount =
  //   parseInt(quotationData.totalAmount) - parseInt(paymentList.taxableValue)
  // const totalPackageAmount =
  //   parseInt(paymentList.totalValue) + parseInt(withoutTaxAmount)

  //Edit payment value

  const editPaymentValue = (data) => {
    const payment = data.data
    setGstPercentage({ label: payment.taxPercentage, value: "" })
    setPaymentData({
      ...paymentData,
      amount: payment.taxableValue,
      gst: [{ label: payment.taxPercentage, value: "" }],
    })
    setPaymentSet(true)
    setUpdatePayment(true)
  }

  //Update payment value
  const updatePaymentValue = () => {
    const payments = {
      leadId: id,
      _id: paymentId,
      quotationdId: quotationData.leadQuotationId,
      mode: "tax",
      data: {
        taxableValue: parseFloat(paymentData.amount),
        taxPercentage: gstPercentage.label,
        taxPercentageId: gstPercentage.value,
        taxAmount: gstAmount,
        totalValue: totalGst,
      },
    }
    specificDispatch(salesAction.updateSalesTempRecord(payments))
    setTimeout(() => {
      specificDispatch(salesAction.loadSalesTempList(id))
      setPaymentSet(false)
      // setValueTotal(true)
    }, 2000)
  }

  //Delete Tax value
  const deleteTaxValue = (success) => {
    specificDispatch(salesAction.deleteSalesTempRecord(paymentId, success))

    setTimeout(() => {
      specificDispatch(salesAction.loadSalesTempList(id))
      setPaymentSet(false)
      // setValueTotal(true)
    }, 2000)
  }

  const totalValuesArray =
    !isEmpty(sales_payment_list) && sales_payment_list.length > 0
      ? sales_payment_list.map((sales) => {
        if (sales.mode == "tax") {
          return sales
        }
      })
      : []
  const totalValuesArrayDetails =
    !isEmpty(totalValuesArray) && totalValuesArray.length > 0
      ? totalValuesArray.filter((data) => data != undefined)
      : []

  const totalValueDetails =
    totalValuesArrayDetails && totalValuesArrayDetails.length > 0
      ? totalValuesArrayDetails
        .map((data) => data.data.totalValue)
        .reduce((a, b) => {
          if (a === 0 || a === undefined) {
            return parseInt(b) + 0
          } else if (b === 0 || b === undefined) {
            return parseInt(a) + 0
          } else {
            return parseInt(a) + parseInt(b)
          }
        })
      : 0

  const totalGstDetailsArray =
    !isEmpty(sales_payment_list) && sales_payment_list.length > 0
      ? sales_payment_list.map((sales) => {
        if (sales.mode == "tax") {
          return sales
        }
      })
      : []
  console.log(totalGstDetailsArray, "totalGstDetailsArray")

  const totalGstDetailsArrayDetails =
    !isEmpty(totalGstDetailsArray) && totalGstDetailsArray.length > 0
      ? totalGstDetailsArray.filter((data) => data != undefined)
      : []
  console.log(totalGstDetailsArrayDetails, "totalGstDetailsArrayDetails")
  const totalGstDetails =
    totalGstDetailsArrayDetails && totalGstDetailsArrayDetails.length > 0
      ? totalGstDetailsArrayDetails
        .map((data) => data.data.taxableValue)
        .reduce((a, b) => {
          if (a === 0 || a === undefined) {
            return parseInt(b) + 0
          } else if (b === 0 || b === undefined) {
            return parseInt(a) + 0
          } else {
            return parseInt(a) + parseInt(b)
          }
        })
      : 0
  //#c5ff00
  console.log(sales_payment_list, "sales_payment_list")
  console.log(totalGstDetails, "totalGstDetails")
  console.log(totalValueDetails, "totalValueDetails")
  console.log(quotationData, "quotationData")

  const totalWithoutTax =
    parseInt(quotationData.totalAmount) - parseInt(totalGstDetails)

  // const totalWithoutTax = quotationData.totalAmount - totalGstDetails
  console.log(totalWithoutTax, "totalWithoutTax")

  const totalPayableValue = totalValueDetails + totalWithoutTax

  console.log(paymentList, "paymentList", paymentList.totalValue)

  //Add paymentTerms value

  const [checked, setChecked] = useState(false)

  const [paymentFormData, setPaymentFormData] = useState([])
  const [termsId, setTermsId] = useState("")

  const [paymentModal, setPaymentModal] = useState(false)
  const handlePaymentClose = () => setPaymentModal(false)

  const [uploadInput, setUploadInput] = useState([])
  // const [uploadClick, setUploadClick] = useState(false)

  const uploadPaymentVoice = (e) => {
    if (e.target.files) {
      console.log("qqqq", e.target.files)
      setUploadInput(e.target.files)
      var file = e.target.files
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = uploadInput

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api
          .post("/image_upload", formData)
          .then(async (res) => {
            if (res && res.data && res.data.data) {
              teamUploadValue.push(res.data.data)
              await setUploadInput(teamUploadValue)
            } else {
              alert("Upload Failed!. Please try again")
            }
          })
          .catch(() => {
            alert("Unable to Upload file")
          })
      }
    }
  }
  const uploadTransactionFile = (e) => {
    if (e.target.files) {
      console.log("qqqq", e.target.files)
      setTransactionUpload(e.target.files)
      var file = e.target.files
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = transactionUpload

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api
          .post("/image_upload", formData)
          .then(async (res) => {
            if (res && res.data && res.data.data) {
              teamUploadValue.push(res.data.data)
              await setTransactionUpload(teamUploadValue)
            } else {
              alert("Upload Failed!. Please try again")
            }
          })
          .catch(() => {
            alert("Unable to Upload file")
          })
      }
    }
  }
  const [clientTypeModal, setClientTypeModal] = useState(false)
  const [quotationRange, setQuotationRange] = useState([])
  const simpleEscalationValidator = useRef(new SimpleReactValidator())
  const [, forcedUpdate] = useState()
  const updateClientType = () => {
    if (simpleEscalationValidator.current.allValid()) {
      const payload = {
        "leadId": id,
        "leadQuotationRange": quotationRange.value,
      }
      console.log(payload)
      setClientTypeModal(false)
      dispatch(clientAction.updateClientType(payload))
      setTimeout(() => {
        dispatch(clientAction.loadRecordClientProfileById({
          mode: "SALES",
          clientId: clientId,
        }))

        toast.success("Client Type Updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
      }, 200)

    } else {
      simpleEscalationValidator.current.showMessages()
      forcedUpdate(1)
      setClientTypeModal(true)
    }
  }
  // const uploadInvoice = () => {
  //   const formData = new FormData()
  //   formData.append("uploadInput", uploadInput)
  //   formData.append("uploadInputName", uploadInput.length)
  //   setUploadClick(true)
  // }

  //Payment Terms section

  const [paymentTermsSet, setPaymentTermsSet] = useState(false)
  const [updatePaymentTerms, setUpdatePaymentTerms] = useState(false)

  const [paymentTerms, setPaymentTerms] = useState([])
  const [paymentTermsData, setPaymentTermsData] = useState({
    quotationId: "",
    paymentDate: "",
    amount: "",
    paymentTerms: [],
  })

  const paymentTermsChange = (e) => {
    setPaymentTermsData({
      ...paymentTermsData,
      [e.target.name]: e.target.value,
    })
  }

  //total package value from payment value section
  const withoutTax =
    parseInt(quotationData.totalAmount) - parseInt(paymentData.amount)

  const totalPackage = parseInt(totalGst) + parseInt(withoutTax)
  console.log(totalPackage, "totalPackage")
  //Onchange for advance payment
  const paymentAdvanceValue = (e) => {
    setPaymentTerms(e)
    var payment = transactionData
    payment.date =
      !isEmpty(e) && e && e.label === "ADVANCE PAYMENT"
        ? paymentTermsData.paymentDate
        : (e && e.label === "2ND TERMS PAYMENT") ||
          (e && e.label === "3RD TERMS PAYMENT")
          ? ""
          : transactionData.date
    payment.amount =
      !isEmpty(e) && e && e.label === "ADVANCE PAYMENT"
        ? paymentTermsData.amount
        : (e && e.label === "2ND TERMS PAYMENT") ||
          (e && e.label === "3RD TERMS PAYMENT")
          ? ""
          : transactionData.amount
    setTransactionData(payment)
  }

  const advancePaymentId = "632c193f4229faaf0d99059a"

  //Add more payment terms

  const addPaymentTermsValue = () => {
    setPaymentTermsData({
      paymentDate: "",
      amount: "",
      paymentTerms: "",
    })
    setPaymentTerms([])
    setPaymentTermsSet(true)
    setUpdatePaymentTerms(false)
  }

  //Add payment value
  const handlePaymentTermsValue = () => {
    if (simpleValidator.current.allValid()) {
      const payments = {
        leadId: id,
        quotationdId: quotationData.leadQuotationId,
        mode: "payment",
        data: {
          amount: paymentTermsData.amount,
          date: paymentTermsData.paymentDate,
          paymentTermsId: paymentTerms.value,
        },
      }
      specificDispatch(salesAction.createSalesTempRecord(payments))
      setTimeout(() => {
        specificDispatch(salesAction.loadSalesTempList(id))
        setPaymentTermsSet(false)
      }, 2000)
      setPaymentFormData([payments])
    } else {
      simpleValidator.current.showMessages()
      setForceUpdate(true)
      setPaymentTermsSet(true)
      console.log(forceUpdate)
      return false
    }
  }

  //Edit payment Terms value
  const editPaymentTermsValue = (payment) => {
    const payments = payment.data
    setPaymentTerms({
      label: payments.paymentTermsName,
      value: payments.paymentTermsId,
    })
    setPaymentTermsData({
      ...paymentTermsData,
      quotationId: payment.quotationId,
      paymentDate: payments.date,
      amount: payments.amount,
      paymentTerms: [
        { label: payments.paymentTermsName, value: payments.paymentTermsId },
      ],
    })
    setPaymentTermsSet(true)
    setUpdatePaymentTerms(true)
  }
  //Update payment Terms value
  const updatePaymentTermsValue = () => {
    const payments = {
      leadId: id,
      _id: termsId,
      quotationdId: quotationData.leadQuotationId,
      mode: "payment",
      data: {
        amount: paymentTermsData.amount,
        date: paymentTermsData.paymentDate,
        paymentTermsId: paymentTerms.value,
      },
    }
    specificDispatch(salesAction.updateSalesTempRecord(payments))
    setTimeout(() => {
      specificDispatch(salesAction.loadSalesTempList(id))
      setPaymentTermsSet(false)
    }, 2000)
  }

  //Delete payment Terms value
  const deletePaymentTermsValue = (success) => {
    specificDispatch(salesAction.deleteSalesTempRecord(termsId, success))
    setTimeout(() => {
      specificDispatch(salesAction.loadSalesTempList(id))
      setPaymentTermsSet(false)
      // setValueTotal(true)
    }, 2000)
  }

  //Transaction section
  const [withoutAdvance, setWithoutAdvance] = useState(false)

  const [advance, setAdvance] = useState("")
  const [transactionUpload, setTransactionUpload] = useState([])
  // const [transactionClick, setTransactionClick] = useState(false)

  // const uploadTransactionFile = (e) => {
  //   // setTimeout(() => {
  //   //   setUploadInput(uploadInput + 1)
  //   // }, 3000)
  //   setTransactionUpload([e.target.files.length])

  //   // setUploadInput([e.target.files])
  // }
  // const transactionInvoice = () => {
  //   const formsData = new FormData()
  //   formsData.append("transactionUpload", transactionUpload)
  //   formsData.append("transactionUploadName", transactionUpload.length)
  //   setTransactionClick(true)
  // }

  const [paymentMode, setPaymentMode] = useState([])
  console.log(paymentMode, "paymentMode")
  // const [account, setAccount] = useState([])
  // const [modeChange, setModeChange] = useState(false)
  const [listShow, setListShow] = useState(false)

  const [transactionData, setTransactionData] = useState([
    // {
    //   date: "",
    //   amount: "",
    //   paymentMode: "",
    //   account: "",
    //   attachment: "",
    //   remarks: "",
    // },
  ])

  useEffect(() => {
    // if(isEmpty(sales_list)) {
    const sales_payment_list_data = sales_payment_list.map((data) => {
      // const finalAmount = service.quantity * service.amount
      //const paymentTerms = data && data.data.paymentTermsName
      if (
        data.mode === "payment" &&
        data.data.paymentTermsName === "ADVANCE PAYMENT"
      ) {
        console.log("sales_payment_list_data123", data)
        return {
          totalAmount: data.data.amount,
          amount: data.data.amount,
          date: data.data.date,
          // paymentTermsId: data.data.paymentTermsId,
          // paymentTermsName: data.data.paymentTermsName,
          paymentMode: "",
          account: "",
          // attachment: "",
          remarks: "",
        }
      }
    })
    const salesDetailsList =
      sales_payment_list_data &&
      sales_payment_list_data.filter((data) => {
        return data !== undefined
      })
    setTransactionData(salesDetailsList)

    // }

    console.log(sales_list, "sales_listsales_list")

    if (
      sales_list &&
      sales_list.advanceDetail &&
      sales_list.advanceDetail.length > 0
    ) {
      let sales_list_advanceDetail = sales_list.advanceDetail

      const sales_list_advanceDetail_data = sales_list_advanceDetail.map(
        (sales) => {
          return {
            //totalAmount: sales.amount,
            amount: sales.amount,
            date:
              sales && sales.date
                ? moment(sales.date).format("YYYY-MM-DD")
                : "",
            paymentMode: sales.paymentModeId
              ? {
                label: sales.paymentModeName,
                value: sales.paymentModeId,
              }
              : [],
            remarks: sales.remarks,
          }

          // setTransactionData(sales_list_advanceDetail_data)
        }
      )
      const salesGetDetailsList =
        sales_list_advanceDetail_data &&
        sales_list_advanceDetail_data.filter((data) => {
          return data !== undefined
        })
      setTransactionData(salesGetDetailsList)
      console.log(
        "sales_list_advanceDetail_data",
        sales_list_advanceDetail_data
      )
    }
  }, [sales_payment_list, sales_list])

  useEffect(() => {
    console.log("paymentTerms", paymentTerms)

    if (paymentTerms.label === "ADVANCE PAYMENT") {
      setTransactionData([
        ...transactionData,
        {
          date: paymentTermsData.paymentDate,
          amount: paymentTermsData.amount,
          paymentMode: "",
          account: "",
          attachment: "",
          remarks: "",
        },
      ])
    }

    console.log("transactionData123", transactionData)
  }, [paymentTerms])

  const transactionChange = (e, index) => {
    let transactionDataArray = transactionData
    let transactionDataObj = transactionData[index]

    if (
      e.target.value != "" &&
      e.target.name == "amount" &&
      isNaN(parseFloat(e.target.value))
    ) {
      return false
    }

    if (
      e.target.value != "" &&
      e.target.name == "amount" &&
      parseFloat(transactionDataObj.totalAmount) < parseFloat(e.target.value)
    ) {
      return false
    }

    transactionDataObj[`${e.target.name}`] = e.target.value
    transactionDataArray[index] = transactionDataObj
    setTransactionData(transactionDataArray)
    //setTransactionData({ ...transactionData, [e.target.name]: e.target.value })
    // setChecked(true)
    // setWithoutAdvance(false)
    // setAdvance("1")
    setPageLoad(!pageLoad)
  }

  //payment mode onchange

  const paymentModeChange = (e, index) => {
    let transactionDataArray = transactionData
    let transactionDataObj = transactionData[index]
    transactionDataObj.paymentMode = e
    transactionDataArray[index] = transactionDataObj
    setTransactionData(transactionDataArray)
    //  setChecked(true)
    //  setWithoutAdvance(false)
    //  setAdvance("2")
    console.log(e, "payment mode selection")
    setPageLoad(!pageLoad)
  }
  const accountChange = (e, index) => {
    let transactionDataArray = transactionData
    let transactionDataObj = transactionData[index]
    transactionDataObj.account = e
    transactionDataArray[index] = transactionDataObj
    setTransactionData(transactionDataArray)
    //  setChecked(true)
    //  setWithoutAdvance(false)
    //  setAdvance("2")
    console.log(e, "payment mode selection")
    setPageLoad(!pageLoad)
  }

  const bankDetails =
    !isEmpty(bank_details) &&
    bank_details.map((bank) => {
      return {
        _id: bank._id,
        companyId: bank.companyId,
        displayName: bank.displayName,
        accountNo: bank.accountNo,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelBankDetails = element.displayName.concat(
          " - ",
          element.accountNo
        )
        let obj = {}
        obj.value = element._id
        obj.label = labelBankDetails
        obj.companyId = element.companyId
        options.push(obj)
      })
    return options
  }

  const bankOptions = createOptions(bankDetails)

  //Confirm Modal
  const [salesConfirmModal, setSalesConfirmModal] = useState(false)
  const handleSalesModal = () => setSalesConfirmModal(false)

  const handleSales = (success) => {
    // if (simpleValidator.current.allValid()) {

    const paymentSubmit = !isEmpty(sales_payment_list)
      ? sales_payment_list.map((data) => {
        // const finalAmount = service.quantity * service.amount

        if (data.mode === "tax") {
          return {
            taxAmount: data.data.taxAmount,
            taxPercentage: data.data.taxPercentage,
            taxPercentageId: data.data.taxPercentageId,
            taxableValue: data.data.taxableValue,
            totalValue: data.data.totalValue,
          }
        }
      })
      : []

    const paymentTermsSubmit = !isEmpty(sales_payment_list)
      ? sales_payment_list.map((data) => {
        // const finalAmount = service.quantity * service.amount

        if (data.mode === "payment") {
          return {
            amount: data.data.amount,
            date: data.data.date,
            paymentTermsId: data.data.paymentTermsId,
            paymentTermsName: data.data.paymentTermsName,
          }
        }
      })
      : []

    const advanceDetailsSubmit = !isEmpty(transactionData)
      ? transactionData.map((data) => {
        // const finalAmount = service.quantity * service.amount
        return {
          amount: data.amount,
          date: data.date,
          paymentModeId: data.paymentMode.value,
          attachment: data.attachment,
          remarks: data.remarks,
        }
      })
      : []
    const salesListData = {
      leadId: id,
      quotationdId: quotationData.leadQuotationId,
      remarks: "remarks",
      billingName: salesData.billingName,
      gstNo: salesData.gstNo,
      billingAddress1: salesData.billingAddress,
      billingAddress2: salesData.billingAddress_1,
      accountantNotes: salesData.accountantNotes,
      withTaxAmount: totalGstAmount + "",
      withoutTaxedAmount: paymentData.amount,
      attachment: "attachment",
      proceedWithoutAdvance: "1",
      payments: paymentTermsSubmit.filter(function (item) {
        return item != null
      }),
      advanceDetail: advanceDetailsSubmit.filter(function (item) {
        return item != null
      }),
      taxSplit: paymentSubmit.filter(function (item) {
        return item != null
      }),
    }
    specificDispatch(salesAction.createSalesRecord(salesListData, success))
    setIsLoading(true)
    setUpdateStatus(false)
    setTimeout(() => {
      specificDispatch(salesAction.loadSalesList(id))
      setListShow(true)
      setIsLoading(false)
      toast.success("Sales Added Successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 2000)
    // } else {
    //   simpleValidator.current.showMessages()
    //   setForceUpdate(true)
    //   setListShow(false)
    //   console.log(forceUpdate)
    //   return false
    // }
  }

  const updateSalesDetails = (success) => {
    const paymentSubmit = !isEmpty(sales_payment_list)
      ? sales_payment_list.map((data) => {
        // const finalAmount = service.quantity * service.amount

        if (data.mode === "tax") {
          return {
            taxAmount: data.data.taxAmount,
            taxPercentage: data.data.taxPercentage,
            taxPercentageId: data.data.taxPercentageId,
            taxableValue: data.data.taxableValue,
            totalValue: data.data.totalValue,
          }
        }
      })
      : []

    const paymentTermsSubmit = !isEmpty(sales_payment_list)
      ? sales_payment_list.map((data) => {
        // const finalAmount = service.quantity * service.amount

        if (data.mode === "payment") {
          return {
            amount: data.data.amount,
            date: data.data.date,
            paymentTermsId: data.data.paymentTermsId,
            paymentTermsName: data.data.paymentTermsName,
          }
        }
      })
      : []
    const advanceDetailsSubmit = !isEmpty(transactionData)
      ? transactionData.map((data) => {
        // const finalAmount = service.quantity * service.amount
        return {
          amount: data.amount,
          date: data.date,
          paymentModeId: data.paymentMode.value,
          attachment: data.attachment,
          remarks: data.remarks,
        }
      })
      : []

    const salesListData = {
      leadId: id,
      quotationdId: quotationData.leadQuotationId,
      salesId: !isEmpty(sales_list) && sales_list._id,
      remarks: "remarks",
      billingName: salesData.billingName,
      gstNo: salesData.gstNo,
      billingAddress1: salesData.billingAddress,
      billingAddress2: salesData.billingAddress_1,
      accountantNotes: salesData.accountantNotes,
      withTaxAmount: totalGstAmount + "",
      withoutTaxedAmount: paymentData.amount,
      attachment: "attachment",
      proceedWithoutAdvance: "1",
      payments: paymentTermsSubmit.filter(function (item) {
        return item != null
      }),
      advanceDetail: advanceDetailsSubmit.filter(function (item) {
        return item != null
      }),
      taxSplit: paymentSubmit.filter(function (item) {
        return item != null
      }),
    }

    // const qcRequestData = {
    //   qcId: "633658ec3dfb8903b5bd005e",
    //   qcStatus: "PS6",
    //   remarks: "QC failed",
    // }
    specificDispatch(salesAction.updateSalesRecord(salesListData, success))
    // if (salesManagerId === "6394779685898637927c8f5b") {
    //   console.log(qcRequestData, "qcRequestData", success)
    //   specificDispatch(salesAction.updateSalesQcReapprove(qcRequestData))
    //   toast.success("Sales Updated Successfully", {
    //     position: toast.POSITION.TOP_RIGHT,
    //     autoClose: 1000,
    //   })
    // }
    setIsLoading(true)
    setUpdateStatus(true)
    setTimeout(() => {
      specificDispatch(salesAction.loadSalesList(id))
      setListShow(true)
      setIsLoading(false)
    }, 2000)
  }

  const options = [
    {
      id: 1,
      label: "Client",
      value: "client",
    },
    {
      id: 2,
      label: "Company",
      value: "company",
    },
  ]
  console.log(sales_list, "sales list from get api")
  console.log(sales_list.billingName, "sales list from get api")
  console.log(paymentFormData, advance, listShow, "sales list from get api")

  useEffect(() => {
    if (
      // salesManagerId === "61bcb7ed0e04359342e992f6" ||
      salesManagerId === "6394779685898637927c8f5b"
    ) {
      setSalesList(false)
      setPaymentMode({
        label: !isEmpty(sales_list) && sales_list.advanceDetail.paymentModeName,
        value: "",
      })
      salesData.billingName =
        !isEmpty(sales_list) && sales_list.billingName
          ? !isEmpty(sales_list) && sales_list.billingName
          : ""
      salesData.gstNo =
        !isEmpty(sales_list) && sales_list.gstNo
          ? !isEmpty(sales_list) && sales_list.gstNo
          : ""
      salesData.billingAddress =
        !isEmpty(sales_list) && sales_list.billingAddress1
          ? !isEmpty(sales_list) && sales_list.billingAddress1
          : ""
      salesData.billingAddress_1 =
        !isEmpty(sales_list) && sales_list.billingAddress2
          ? !isEmpty(sales_list) && sales_list.billingAddress2
          : ""
      salesData.accountantNotes =
        !isEmpty(sales_list) && sales_list.accountantNotes
          ? !isEmpty(sales_list) && sales_list.accountantNotes
          : ""
      // setTransactionData(...transactionData, [
      //   {
      //     amount:
      //       !isEmpty(sales_list) && sales_list.advanceDetail.amount
      //         ? !isEmpty(sales_list) && sales_list.advanceDetail.amount
      //         : "",
      //     paymentMode: [
      //       {
      //         label:
      //           !isEmpty(sales_list) &&
      //           sales_list.advanceDetail.paymentModeName,
      //         value: "",
      //       },
      //     ],
      //     remarks:
      //       !isEmpty(sales_list) && sales_list.advanceDetail.remarks
      //         ? !isEmpty(sales_list) && sales_list.advanceDetail.remarks
      //         : "",
      //     date: moment(
      //       !isEmpty(sales_list) && sales_list.advanceDetail.date
      //     ).format("YYYY-MM-DD"),
      //   },
      // ])
    }
  }, [salesManagerId])

  useEffect(() => {
    if (!isEmpty(sales_list)) {
      setSalesList(true)
      // setPaymentMode({
      //   label: !isEmpty(sales_list) && sales_list.advanceDetail.paymentModeName,
      //   value: "",
      // })
      salesData.billingName =
        !isEmpty(sales_list) && sales_list.billingName
          ? !isEmpty(sales_list) && sales_list.billingName
          : ""
      salesData.gstNo =
        !isEmpty(sales_list) && sales_list.gstNo
          ? !isEmpty(sales_list) && sales_list.gstNo
          : ""
      salesData.billingAddress =
        !isEmpty(sales_list) && sales_list.billingAddress1
          ? !isEmpty(sales_list) && sales_list.billingAddress1
          : ""
      salesData.billingAddress_1 =
        !isEmpty(sales_list) && sales_list.billingAddress2
          ? !isEmpty(sales_list) && sales_list.billingAddress2
          : ""
      salesData.accountantNotes =
        !isEmpty(sales_list) && sales_list.accountantNotes
          ? !isEmpty(sales_list) && sales_list.accountantNotes
          : ""
      // setTransactionData([
      //   {
      //     ...transactionData,
      //     amount:
      //       !isEmpty(sales_list) &&
      //       sales_list.advanceDetail.map((data) => data.amount)
      //         ? !isEmpty(sales_list) &&
      //           sales_list.advanceDetail.map((data) => data.amount)
      //         : "",
      //     paymentMode: [
      //       {
      //         label:
      //           !isEmpty(sales_list) &&
      //           sales_list.advanceDetail.map((data) => data.paymentModeName),
      //         value: "",
      //       },
      //     ],
      //     remarks: !isEmpty(sales_list)
      //       ? !isEmpty(sales_list) &&
      //         sales_list.advanceDetail.map((data) => data.remarks)
      //       : "",
      //     date: moment(
      //       !isEmpty(sales_list) &&
      //         sales_list.advanceDetail.map((data) => data.date)
      //     ).format("YYYY-MM-DD"),
      //   },
      // ])
    }
    console.log(sales_list, "kkk_sales_list_fom_api")
  }, [sales_list])

  return (
    <React.Fragment>
      <Row>
        {/* Button Section */}
        <Col
          md="12"
          lg="12"
          xl="12"
          sm="12"
          xs="12"
          className="quote-head-content"
        >
          <Row>
            <Col className="mb-3">
              <p className="quote-head ms-1">
                Sales
                <span className="quote-info">
                  <i
                    style={{ color: "grey" }}
                    id="quoteInfo"
                    aria-hidden="true"
                    className="fa fa-info-circle ms-1"
                  ></i>
                  <UncontrolledTooltip placement="right" target="quoteInfo">
                    Sales Details Description
                  </UncontrolledTooltip>
                </span>
              </p>
            </Col>
            <Col className="sales-button-main">
              {
                // salesManagerId === "61bcb7ed0e04359342e992f6" ||
                salesManagerId === "6394779685898637927c8f5b" &&
                  !isEmpty(sales_list) ? (
                  <div
                    className={"create-sales-btn color-success"}
                    onClick={() => {
                      setSalesList(false)
                      // setIsEdit(false)
                      setIsSalesEdit(true)
                      // handleCreate()
                    }}
                  >
                    <i className="fas fa-edit mx-1"></i> Edit Sales
                  </div>
                ) : (
                  ""
                )
              }
              <div
                className={
                  alterSales ||
                    isEmpty(sales_list) ||
                    // salesManagerId === "61bcb7ed0e04359342e992f6" ||
                    salesManagerId === "6394779685898637927c8f5b" ||
                    alterProcessStatus === "PS17"
                    ? "create-sales-btn color-success"
                    : alterProcessStatus === "PS6" ||
                      salesManagerId === "6394779685898637927c8f5b"
                      ? "create-sales-btn color-success"
                      : "create-sales-btn color-success disabled-button"
                }
                onClick={() => {
                  setRequestModal(true)
                  // setIsEdit(false)
                  // handleCreate()
                }}
              >
                <i className="fas fa-reply mx-1"></i> Alter Sales
              </div>
              <button
                style={{
                  color: "#e40d8c",
                  border: "1.8px solid #e40d8c",
                  background: "#ffffff",
                }}
                className={
                  // salesList === false || alterProcessStatus === "PS17"
                  // ?
                  "create-sales-btn color-success"
                  // : alterProcessStatus === "PS6" ? "create-sales-btn color-success" : "create-sales-btn color-success disabled-button"
                }
                onClick={() => setAlterQuoteModal(true)}
              >
                <i className="fa fa-reply mx-1"></i> Alter Quote
              </button>
              <div className="create-sales-btn">
                <i className="fas fa-plus mx-1"></i>Call Now
              </div>
              <button
                style={{
                  color: "#50a5f1",
                  border: "1.8px solid #50a5f1",
                  background: "#ffffff",
                }}
                className={
                  // isEmpty(sales_list) ||
                  // salesList === false &&
                  alterProcessStatus !== "PS9"
                    ? "create-sales-btn disabled-button"
                    : "create-sales-btn"
                }
                onClick={() => handleSalesServicePreview(true)}
              >
                <i className="fas fa-eye mx-1"></i>
                Service Confirmation
              </button>
              {/* <div
                className="create-sales-reject-btn"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setRejectModal(true)
                  rejectBtn()
                }}
              >
                <i className="fas fa-trash mx-1"></i>Rejected
              </div> */}
            </Col>
          </Row>
        </Col>
        {/* Sales Alter Modal */}

        {requestModal && (
          <Modal show={requestModal} onHide={handleRequestClose}>
            <Modal.Header
              style={{
                fontWeight: 600,
                backgroundColor: "#e83e8c",
                fontSize: "16px",
                color: "#ffffff",
              }}
            >
              Alter Sales Request:
            </Modal.Header>
            <Modal.Body>
              <Col
                xl="12"
                lg="12"
                md="12"
                sm="12"
                xs="12"
                className="d-flex flex-column"
              >
                <Label className="event-label">Remarks</Label>
                <textarea
                  type="text"
                  name="qcRemarks"
                  value={qcRemarks}
                  onChange={(e) => setQcRemarks(e.target.value)}
                  placeholder="Enter Remarks"
                  className="event-crowd-textarea"
                />
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleRequestClose}
              >
                Close
              </Button>
              {/* <Link to={"/sales-approval"}> */}
              <Button
                variant="primary"
                className="btn btn-success"
                onClick={() => {
                  handleApproval()
                  handleRequestClose()
                  // setListShow(true)
                }}
              >
                Send Request
              </Button>
              {/* </Link> */}
            </Modal.Footer>
          </Modal>
        )}
        {/* //Alter quote */}
        {alterQuoteModal && (
          <Modal show={alterQuoteModal} onHide={handleAlterQuoteClose}>
            <Modal.Header
              style={{
                fontWeight: 600,
                backgroundColor: "#e83e8c",
                fontSize: "16px",
                color: "#ffffff",
              }}
            >
              Alter Quote Request:
            </Modal.Header>
            <Modal.Body>
              <Col
                xl="12"
                lg="12"
                md="12"
                sm="12"
                xs="12"
                className="d-flex flex-column"
              >
                <Label className="event-label">Remarks</Label>
                <textarea
                  type="text"
                  name="alterQcRemarks"
                  value={alterQcRemarks}
                  onChange={(e) => setAlterQcRemarks(e.target.value)}
                  placeholder="Enter Remarks"
                  className="event-crowd-textarea"
                />
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleAlterQuoteClose}
              >
                Close
              </Button>
              {/* <Link to={"/sales-approval"}> */}
              <Button
                variant="primary"
                className="btn btn-success"
                onClick={() => {
                  handleAlterQuote()
                  handleAlterQuoteClose()
                  // setListShow(true)
                }}
              >
                Send Request
              </Button>
              {/* </Link> */}
            </Modal.Footer>
          </Modal>
        )}
        {/* //Request loader */}
        {qcRequestLoading ? (
          <div>
            <Modal
              show={qcRequestLoading}
              style={{
                width: "16%",
                margin: "20% 50%",
                background: "none",
              }}
            >
              <Modal.Body className="d-flex flex-column align-items-center">
                <Spinner
                  as="span"
                  animation="grow"
                  size="md"
                  role="status"
                  aria-hidden="true"
                  variant="success"
                  className="mb-2"
                />
                <span>{"Qc request Sent"}</span>
                <span>please wait....</span>
              </Modal.Body>
            </Modal>
          </div>
        ) : (
          ""
        )}

        {/* Sales details Form */}
        <>
          <Col md="12" xl="12" lg="12" className="mt-1 mb-3">
            <Row>
              <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                <Label className="event-label">Quotation No</Label>
                <Input
                  name="quotationNo"
                  disabled
                  value={
                    salesList === true && salesList === false
                      ? !isEmpty(sales_list) && sales_list.salesNo
                      : quotationData.leadQuotationNumber
                        ? quotationData.leadQuotationNumber
                        : ""
                  }
                  placeholder="Quotation No"
                />
              </Col>
              <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                <Label className="event-label">Quotation Date</Label>
                <Input
                  type="text"
                  disabled
                  name="quotationDate"
                  value={
                    salesList === true
                      ? !isEmpty(sales_list) && sales_list.salesDate
                      : quotationDate
                  }
                  placeholder="Quotation Date"
                />
              </Col>
              <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                <Label className="event-label">Sales Executive</Label>
                <Input
                  type="text"
                  disabled
                  name="salesExecutive"
                  value={salesExecutive}
                  placeholder="Sales Executive"
                />
              </Col>
              <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                <Label className="event-label">Billing Name</Label>
                <Input
                  type="text"
                  name="billingName"
                  // disabled={
                  //   listShow === true ? false : isEdit === true ? false : true
                  // }
                  disabled={salesList === true ? true : false}
                  value={salesData.billingName}
                  onChange={(e) => handleChange(e)}
                  placeholder="Enter Billing Name"
                />
              </Col>
              <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                <Label className="event-label">GST No</Label>
                <Input
                  type="text"
                  name="gstNo"
                  disabled={salesList === true ? true : false}
                  value={salesData.gstNo}
                  onChange={(e) => handleChange(e)}
                  placeholder="Enter GST No"
                />
              </Col>
              <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                <Label className="event-label">Billing Address 1</Label>
                <Input
                  type="text"
                  name="billingAddress"
                  disabled={salesList === true ? true : false}
                  value={salesData.billingAddress}
                  onChange={(e) => handleChange(e)}
                  placeholder="Enter Address 1"
                />
              </Col>
              <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                <Label className="event-label">Billing Address 2</Label>
                <Input
                  type="text"
                  name="billingAddress_1"
                  disabled={salesList === true ? true : false}
                  value={salesData.billingAddress_1}
                  onChange={(e) => handleChange(e)}
                  placeholder="Enter Address 2"
                />
              </Col>
              <Col
                xl="8"
                lg="8"
                md="8"
                sm="12"
                xs="12"
                className="d-flex flex-column mt-3"
              >
                <Label className="event-label">Accountant Notes</Label>
                <textarea
                  type="text"
                  name="accountantNotes"
                  disabled={salesList === true ? true : false}
                  value={salesData.accountantNotes}
                  onChange={(e) => handleChange(e)}
                  placeholder="Enter Accountant Notes"
                  className="event-crowd-textarea"
                />
              </Col>
              <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                <Label className="event-label">Client Type</Label>

                <div style={{ display: "flex" }}>

                  {!isEmpty(clientProfile) &&
                    clientProfile[0].leadQuotationRange ? (
                    <span
                      className={"badge"}
                      style={{
                        backgroundColor:
                          clientProfile[0].leadQuotationRange === "Green" ? "#28a745" :
                              clientProfile[0].leadQuotationRange === "Orange" ? "#FFA500" :
                                clientProfile[0].leadQuotationRange === "Blue" ? "#033dfc" :
                                  "",
                        display: "inline-block",
                        width: "35px",        // Equal width and height for a circle
                        height: "35px",
                        borderRadius: "50%",
                        marginLeft:"20px"
                      }}
                    />
                  ) : (
                    <span>--</span>

                  )}
                  <div style={{marginLeft:"160px"}}>     <Button
                    style={{
                      border: "none",
                      cursor: "pointer",
                      padding: "4px 8px",
                      borderRadius: "3px",

                    }}
                    onClick={() => {
                      // Your action here

                      setClientTypeModal(true)
                      simpleEscalationValidator.current.hideMessages()
                      setQuotationRange([])
                    }}
                    className="btn btn-success"
                  >
                    <i className="fas fa-edit icon-btn" style={{ fontSize: "10px" }}></i>
                  </Button></div>

                </div>
              </Col>
         
            </Row>
            {/* ) */}

            {/* })} */}
          </Col>
          {/* ) : (
            ""
          )} */}

          {/* Events Description */}
          <Col
            md="12"
            xl="12"
            lg="12"
            sm="12"
            xs="12"
            className="mb-3 quote-head-content"
          >
            <p className="quote-head ms-1">
              Events
              <span className="quote-info">
                <i
                  style={{ color: "grey" }}
                  id="eventsInfo"
                  aria-hidden="true"
                  className="fa fa-info-circle ms-1"
                ></i>
                <UncontrolledTooltip placement="right" target="eventsInfo">
                  Events Description
                </UncontrolledTooltip>
              </span>
            </p>
          </Col>

          {isLoading ? (
            <div>
              <Modal
                show={isLoading}
                style={{
                  width: "16%",
                  margin: "20% 50%",
                  background: "none",
                }}
              >
                <Modal.Body className="d-flex flex-column align-items-center">
                  <Spinner
                    as="span"
                    animation="grow"
                    size="md"
                    role="status"
                    aria-hidden="true"
                    variant="success"
                    className="mb-2"
                  />
                  <span>{updateStatus ? "updated" : "submitted"}</span>
                  <span>please wait....</span>
                </Modal.Body>
              </Modal>
            </div>
          ) : (
            ""
          )}
          {eventUpdate ? (
            <Col md="12" xl="12" lg="12" className="mt-1">
              <Table bordered className="data-table-border">
                <tbody style={{ fontWeight: "550" }}>
                  <tr className="bg-white">
                    <td className="sales-profile">{eventList.eventDate}</td>
                    <td className="sales-profile">{eventList.eventName}</td>
                    <td style={{ width: "25%" }}>
                      <Select
                        name="travel"
                        value={travel}
                        onChange={(e) => setTravel(e)}
                        options={options}
                      />{" "}
                      {isEmpty(travel.value) && inputErrors ? (
                        <>
                          <span
                            style={{
                              color: "#f52323",
                              fontSize: "10px",
                            }}
                          >
                            The travel field is required
                          </span>
                        </>
                      ) : (
                        ""
                      )}
                    </td>
                    <td style={{ width: "24%" }}>
                      <Select
                        name="food"
                        value={food}
                        onChange={(e) => setFood(e)}
                        options={options}
                      />{" "}
                      {isEmpty(food.value) && inputErrors ? (
                        <>
                          <span
                            style={{
                              color: "#f52323",
                              fontSize: "10px",
                            }}
                          >
                            The food field is required
                          </span>
                        </>
                      ) : (
                        ""
                      )}
                    </td>
                    <td style={{ width: "10%" }}>
                      <div className="d-flex flex-row">
                        <button
                          className="add-button btn btn-warning"
                          onClick={() => {
                            // setSpecialInstructionSet(false)
                            setEventUpdate(false)
                          }}
                        >
                          cancel
                        </button>
                        <button
                          type="submit"
                          className="add-button btn btn-success"
                          onClick={(e) => {
                            updateEventDetails(e)
                          }}
                        >
                          Update
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          ) : (
            ""
          )}

          <Col md="12" xl="12" lg="12" className="mt-1">
            <Table bordered className="data-table-border">
              <thead>
                <tr>
                  <th className="sales-event-table-head">Event Date</th>
                  <th className="sales-event-table-head">Event Name</th>
                  <th className="sales-event-table-head">Travel & Stay By</th>
                  <th className="sales-event-table-head">Food By</th>
                  <th style={{ textAlign: "center" }}>#</th>
                </tr>
              </thead>
              <tbody style={{ fontWeight: "550" }}>
                {!isEmpty(eventData) &&
                  eventData.map((events) => {
                    const eventDate = moment(events.eventDate).format(
                      "DD/MM/YYYY"
                    )

                    return (
                      <tr className="bg-white" key={events._id}>
                        <td className="sales-profile">{eventDate}</td>
                        <td className="sales-profile">{events.eventName}</td>
                        <td style={{ textAlign: "center" }}>
                          {events.travelStay}
                        </td>
                        <td style={{ textAlign: "center" }}>{events.food}</td>
                        <td>
                          <button
                            className={
                              salesList
                                ? "add-button btn btn-info disabled-button"
                                : "add-button btn btn-info"
                            }
                            onClick={() => {
                              editEventDetails(events)
                              setEventId(events._id)
                            }}
                            disabled={salesList === true ? true : false}
                          >
                            Edit
                          </button>
                        </td>
                      </tr>
                    )
                  })}
              </tbody>
            </Table>
          </Col>

          {/* Client details Description */}
          <Col
            md="12"
            xl="12"
            lg="12"
            sm="12"
            xs="12"
            className="mb-3 quote-head-content"
          >
            <p className="quote-head ms-1">
              Client Detail
              <span className="quote-info">
                <i
                  style={{ color: "grey" }}
                  id="clientDetailsInfo"
                  aria-hidden="true"
                  className="fa fa-info-circle ms-1"
                ></i>
                <UncontrolledTooltip
                  placement="right"
                  target="clientDetailsInfo"
                >
                  Client Detail Description
                </UncontrolledTooltip>
              </span>
            </p>
          </Col>
          <Col className="mt-1">
            <Table bordered responsive className="data-table-border">
              <thead>
                <tr>
                  <td className="sales-event-table-head">Bride / Groom</td>
                  <td className="sales-event-table-head">Mobile No</td>
                  <td className="sales-event-table-head">Whats App</td>
                  <td className="sales-event-table-head">Email Id</td>
                </tr>
              </thead>
              <tbody style={{ fontWeight: "550" }}>
                {!isEmpty(clientData) &&
                  clientData.map((client) => {
                    if (client.status === 1) {
                      return (
                        <tr className="bg-white" key={client._id}>
                          <td className="sales-client-name">
                            {client.bride.brideName}
                            <span className="sales-client-profile">
                              (Bride)
                            </span>
                          </td>
                          <td className="sales-profile">
                            {client.bride.brideMobileNo}
                          </td>
                          <td className="sales-profile">
                            {client.bride.brideWhatsappNo}
                          </td>
                          <td className="sales-profile">
                            {client.bride.brideEmailId}
                          </td>
                        </tr>
                      )
                    }
                  })}
                {!isEmpty(clientData) &&
                  clientData.map((client) => {
                    if (client.status === 1) {
                      return (
                        <tr className="bg-white" key={client._id}>
                          <td className="sales-client-name">
                            {client.groom.groomName}
                            <span className="sales-client-profile">
                              (Groom)
                            </span>
                          </td>
                          <td className="sales-profile">
                            {client.groom.groomMobileNo}
                          </td>
                          <td className="sales-profile">
                            {client.groom.groomWhatsappNo}
                          </td>
                          <td className="sales-profile">
                            {client.groom.groomEmailId}
                          </td>
                        </tr>
                      )
                    }
                  })}
              </tbody>
            </Table>
          </Col>
          {/* Package Value section */}
          <Col
            md="12"
            xl="12"
            lg="12"
            sm="12"
            xs="12"
            className="mb-2 quote-head-content"
          >
            <p className="quote-head ms-1">
              Package Value
              <span className="quote-info">
                <i
                  style={{ color: "grey" }}
                  id="packageInfo"
                  aria-hidden="true"
                  className="fa fa-info-circle ms-1"
                ></i>
                <UncontrolledTooltip placement="right" target="packageInfo">
                  Package Value Description
                </UncontrolledTooltip>
              </span>
            </p>
          </Col>
          <Col md="12" xl="12" lg="12">
            <Row>
              <Col className="d-flex flex-row">
                <p className="package-quote-title">Quoted Amount:</p>
                <h2 className="package-quote-amount">
                  {quotationData.totalAmount}.00
                </h2>
              </Col>
              <Col>
                <button
                  className={
                    salesList
                      ? "add-more-button disabled-button"
                      : "add-more-button"
                  }
                  onClick={() => addPaymentValue()}
                  disabled={salesList === true ? true : false}
                >
                  Add More
                </button>
              </Col>
            </Row>
          </Col>
          {/* Packages Table Section */}
          {paymentSet ? (
            <Col md="12" xl="12" lg="12" className="mt-3">
              <Table>
                <tbody>
                  <tr className="bg-white">
                    <td style={{ width: "20%" }}>
                      <Input
                        name="amount"
                        placeholder="Enter amount"
                        value={
                          paymentData.amount <= quotationData.totalAmount
                            ? paymentData.amount
                            : ""
                        }
                        onChange={(e) => {
                          const re = /^[0-9\b/+]+$/
                          if (
                            e.target.value === "" ||
                            re.test(e.target.value)
                          ) {
                            paymentValueChange(e)
                          }
                        }}
                      // onChange={(e) => {
                      //   paymentValueChange(e)
                      // }}
                      />
                      {simpleValidator.current.message(
                        "Amount",
                        paymentData.amount,
                        "required"
                      )}
                    </td>
                    <td style={{ width: "30%" }}>
                      <Select
                        name="gst"
                        placeholder="Select GST%"
                        value={gstPercentage}
                        options={
                          salesMetaData ? salesMetaData.paymentGstOptions : []
                        }
                        onChange={(e) => {
                          setGstPercentage(e)
                          setGstSelected(true)
                        }}
                      />
                      {simpleValidator.current.message(
                        "GST",
                        gstPercentage,
                        "required"
                      )}
                    </td>
                    <td style={{ width: "10%" }}>
                      {isEdit
                        ? sales_payment_list.map((sales) => {
                          const salesAmount =
                            !isEmpty(sales.data) && sales.data
                          if (paymentId === sales._id) {
                            return (
                              <p key={sales._id}>
                                {gstSelected === true
                                  ? amountGst
                                  : salesAmount.taxAmount}
                              </p>
                            )
                          }
                        })
                        : amountGst}
                    </td>
                    <td style={{ width: "10%" }}>
                      {/* {salesList
                        ?  */}
                      {isEdit
                        ? sales_payment_list.map((sales) => {
                          const salesAmount =
                            !isEmpty(sales.data) && sales.data
                          if (paymentId === sales._id) {
                            return (
                              <p key={sales._id}>
                                {gstSelected === true
                                  ? totalGstAmount
                                  : salesAmount.totalValue}
                              </p>
                            )
                          }
                        })
                        : totalGstAmount}
                    </td>
                    {salesList || updatePayment ? (
                      <>
                        <td style={{ width: "15%" }} className="w-10">
                          <div className="d-flex flex-row">
                            <div
                              className="add-button btn btn-warning"
                              onClick={() => {
                                // setSpecialInstructionSet(false)
                                setPaymentSet(false)
                              }}
                            >
                              cancel
                            </div>
                            <div
                              className="add-button btn btn-success"
                              onClick={() => updatePaymentValue()}
                            >
                              Update
                            </div>
                          </div>
                        </td>
                      </>
                    ) : (
                      <>
                        <td style={{ width: "15%" }} className="w-10">
                          <div className="d-flex flex-row">
                            <div
                              className="add-button btn btn-warning"
                              onClick={() => {
                                // setSpecialInstructionSet(false)
                                setPaymentSet(false)
                              }}
                            >
                              cancel
                            </div>
                            <div
                              className="add-button btn btn-success"
                              onClick={() => handlePaymentValue()}
                            >
                              Add
                            </div>
                          </div>
                        </td>
                      </>
                    )}
                  </tr>
                </tbody>
              </Table>
            </Col>
          ) : (
            ""
          )}

          <Col md="12" xl="12" lg="12" className="mt-3">
            <Table bordered responsive className="data-table-border">
              <thead>
                <tr>
                  <th>GST Amount</th>
                  <th>GST %</th>
                  <th>Tax Amount</th>
                  <th>Total GST Package</th>
                  <th style={{ textAlign: "center" }} className="icon-section">
                    #
                  </th>
                  <th className="icon-section">#</th>
                </tr>
              </thead>
              <tbody>
                {!isEmpty(sales_payment_list) &&
                  sales_payment_list.map((data) => {
                    if (data.mode === "tax") {
                      return (
                        <tr className="bg-white" key={data._id}>
                          <td style={{ width: "18%" }}>
                            {data.data.taxableValue}{" "}
                          </td>
                          <td style={{ width: "12%" }}>
                            {data.data.taxPercentage}{" "}
                          </td>
                          <td
                            style={{ width: "20%" }}
                            className="package-value"
                          >
                            {data.data.taxAmount}
                          </td>
                          <td
                            style={{ width: "25%" }}
                            className="package-value"
                          >
                            {data.data.totalValue}
                          </td>
                          <td style={{ width: "10%" }}>
                            <button
                              type="submit"
                              className={
                                salesList
                                  ? "add-button disabled-button"
                                  : "add-button"
                              }
                              onClick={() => {
                                editPaymentValue(data)
                                setIsEdit(true)
                                setPaymentId(data._id)
                              }}
                              disabled={salesList === true ? true : false}
                            >
                              Edit
                            </button>
                          </td>
                          <td style={{ width: "10%" }}>
                            <i
                              className={
                                salesList === true
                                  ? "fa fa-times remove-icon disabled-button"
                                  : "fa fa-times remove-icon"
                              }
                              onClick={() => {
                                setTaxModal(true)
                                setPaymentId(data._id)
                              }}
                            ></i>
                          </td>
                        </tr>
                      )
                    }
                  })}
              </tbody>
            </Table>
            {taxModal && (
              <Modal show={taxModal} onHide={handleTaxClose}>
                <Modal.Header
                  style={{
                    fontWeight: 600,
                    backgroundColor: "#e83e8c",
                    fontSize: "16px",
                    color: "#ffffff",
                  }}
                >
                  Delete Payment Value:
                </Modal.Header>
                <Modal.Body>
                  Are you sure you want to delete the payments value ?
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    className="btn btn-danger"
                    onClick={handleTaxClose}
                  >
                    Close
                  </Button>
                  <Button
                    variant="primary"
                    className="btn btn-success"
                    onClick={() => {
                      handleTaxClose()
                      deleteTaxValue()
                    }}
                  >
                    Delete
                  </Button>
                  {/* </Link> */}
                </Modal.Footer>
              </Modal>
            )}
          </Col>
          {/* Value section */}
          <Col xl="12" lg="12" md="12" className="mt-3 mb-3">
            <Row>
              <Col lg="4" md="6" sm="6" xs="12">
                <div className="value-content">
                  <h2 className="value-title">Package With GST</h2>
                  <h1 className="value-total">
                    Rs.
                    {totalValueDetails ? totalValueDetails : 0}
                    .00
                  </h1>
                </div>
              </Col>
              <Col lg="4" md="6" sm="6" xs="12">
                <div className="value-content">
                  <h2 className="value-title">Package A GST</h2>
                  <h1 className="value-total">
                    Rs. {totalWithoutTax ? totalWithoutTax : 0}
                    .00
                  </h1>
                </div>
              </Col>
              <Col lg="4" md="6" sm="6" xs="12">
                <div className="value-content">
                  <h2 className="value-title">Total Package Value</h2>
                  <h1 className="value-total">
                    Rs.{" "}
                    {totalPayableValue
                      ? totalPayableValue
                      : quotationData.totalAmount}
                    .00
                  </h1>
                </div>
              </Col>
            </Row>
          </Col>
          {/* Payment Terms section */}
          <Col
            md="12"
            xl="12"
            lg="12"
            sm="12"
            xs="12"
            className="mb-2 quote-head-content"
          >
            <p className="quote-head ms-1">
              Payment Terms
              <span className="quote-info">
                <i
                  style={{ color: "grey" }}
                  id="paymentInfo"
                  aria-hidden="true"
                  className="fa fa-info-circle ms-1"
                ></i>
                <UncontrolledTooltip placement="right" target="paymentInfo">
                  Payment Terms Description
                </UncontrolledTooltip>
              </span>
            </p>
          </Col>
          <Col>
            <button
              onClick={() => addPaymentTermsValue()}
              className={
                salesList === true
                  ? "add-more-button disabled-button"
                  : "add-more-button"
              }
              disabled={salesList === true ? true : false}
            >
              Add More
            </button>
          </Col>
          {/* Packages Table Section */}
          {paymentTermsSet ? (
            <Col md="12" lg="12" xl="12" className="mt-3">
              <Table bordered className="data-table-border">
                <tbody>
                  <tr className="bg-white">
                    <td style={{ width: "15%" }}>
                      <Input
                        type="date"
                        name="paymentDate"
                        value={paymentTermsData.paymentDate}
                        onChange={(e) => paymentTermsChange(e)}
                        disabled={salesList === true ? true : false}
                        placeholder="20/07/2022"
                      />
                    </td>
                    <td style={{ width: "20%" }}>
                      <Input
                        type="text"
                        value={
                          paymentTermsData.amount <= totalPayableValue ||
                            paymentTermsData.amount <= quotationData.totalAmount
                            ? paymentTermsData.amount
                            : ""
                        }
                        onChange={(e) => {
                          const re = /^[0-9\b/+]+$/
                          if (
                            e.target.value === "" ||
                            re.test(e.target.value)
                          ) {
                            paymentTermsChange(e)
                          }
                        }}
                        // onChange={(e) => paymentTermsChange(e)}
                        name="amount"
                        disabled={salesList === true ? true : false}
                        placeholder="Enter Amount"
                      />
                      {simpleValidator.current.message(
                        "Amount",
                        paymentTermsData.amount,
                        "required"
                      )}
                    </td>
                    <td style={{ width: "35%" }}>
                      <Select
                        name="paymentTerms"
                        value={paymentTerms}
                        options={
                          salesMetaData ? salesMetaData.paymentTermsOptions : []
                        }
                        onChange={(e) => paymentAdvanceValue(e, paymentTerms)}
                        placeholder="Select Payment Terms"
                        isDisabled={salesList === true ? true : false}
                      />
                    </td>
                    {salesList || updatePaymentTerms ? (
                      <>
                        <td style={{ width: "15%" }} className="w-10">
                          <div className="d-flex flex-row">
                            <div
                              className="add-button btn btn-warning"
                              onClick={() => {
                                // setSpecialInstructionSet(false)
                                setPaymentTermsSet(false)
                              }}
                            >
                              cancel
                            </div>
                            <div
                              className="add-button btn btn-success"
                              onClick={() => updatePaymentTermsValue()}
                            >
                              Update
                            </div>
                          </div>
                        </td>
                      </>
                    ) : (
                      <>
                        <td style={{ width: "15%" }} className="w-10">
                          <div className="d-flex flex-row">
                            <div
                              className="add-button btn btn-warning"
                              onClick={() => {
                                // setSpecialInstructionSet(false)
                                setPaymentTermsSet(false)
                              }}
                            >
                              cancel
                            </div>
                            <div
                              className="add-button btn btn-success"
                              onClick={() => handlePaymentTermsValue()}
                            >
                              Add
                            </div>
                          </div>
                        </td>
                      </>
                    )}
                  </tr>
                </tbody>
              </Table>
            </Col>
          ) : (
            ""
          )}

          <Col md="12" lg="12" xl="12" className="mt-3">
            <Table bordered responsive className="data-table-border">
              <thead>
                <tr>
                  <th className="package-value">Date</th>
                  <th className="package-value">Amount</th>
                  <th>Payment Terms</th>
                  <th style={{ textAlign: "center" }} className="icon-section">
                    #
                  </th>
                  <th className="icon-section">#</th>
                </tr>
              </thead>
              <tbody>
                {!isEmpty(sales_payment_list) &&
                  sales_payment_list.map((payment) => {
                    if (payment.mode === "payment") {
                      return (
                        <tr className="bg-white" key={payment._id}>
                          <td style={{ width: "20%" }}>{payment.data.date}</td>
                          <td style={{ width: "20%" }}>
                            {payment.data.amount}
                          </td>
                          <td style={{ width: "30%" }}>
                            {payment.data.paymentTermsName}
                          </td>
                          <td style={{ width: "15%" }}>
                            <button
                              type="submit"
                              className={
                                salesList === true
                                  ? "add-button disabled-button"
                                  : "add-button"
                              }
                              style={{ textAlign: "center" }}
                              onClick={() => {
                                editPaymentTermsValue(payment)
                                // setPaymentEdit(true)
                                setTermsId(payment._id)
                              }}
                              disabled={salesList === true ? true : false}
                            >
                              Edit
                            </button>
                          </td>
                          <td style={{ width: "10%" }}>
                            <i
                              className={
                                salesList === true
                                  ? "fa fa-times remove-icon disabled-button"
                                  : "fa fa-times remove-icon"
                              }
                              onClick={() => {
                                setPaymentModal(true)
                                setTermsId(payment._id)
                              }}
                            ></i>
                          </td>
                        </tr>
                      )
                    }
                  })}
              </tbody>
            </Table>
            {paymentModal && (
              <Modal show={paymentModal} onHide={handlePaymentClose}>
                <Modal.Header
                  style={{
                    fontWeight: 600,
                    backgroundColor: "#e83e8c",
                    fontSize: "16px",
                    color: "#ffffff",
                  }}
                >
                  Delete Payment Terms:
                </Modal.Header>
                <Modal.Body>
                  Are you sure you want to delete the payments value ?
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    className="btn btn-danger"
                    onClick={handlePaymentClose}
                  >
                    Close
                  </Button>
                  <Button
                    variant="primary"
                    className="btn btn-success"
                    onClick={() => {
                      handlePaymentClose()
                      deletePaymentTermsValue()
                    }}
                  >
                    Delete
                  </Button>
                  {/* </Link> */}
                </Modal.Footer>
              </Modal>
            )}
          </Col>
          <Col md="6" xl="6" sm="6" xs="6" lg="6">
            <div
              // className="file btn btn-info"
              className={
                salesList
                  ? "file btn btn-info disabled-button"
                  : "file btn btn-info"
              }
              disabled={salesList === true ? true : false}
              style={{ overflow: "hidden", position: "relative" }}
            >
              <i
                className="fas fa-paperclip"
                style={{ marginRight: "5px" }}
              ></i>
              Payment Terms Voice
              <Input
                type="file"
                name="uploadInput"
                accept="application/pdf, audio/mp3 , image/jpeg"
                // id="upload-btn"
                multiple
                onChange={(e) => uploadPaymentVoice(e)}
                style={{
                  position: "absolute",
                  fontSize: "50px",
                  opacity: 0,
                  right: 0,
                  top: 0,
                }}
              />
            </div>
            {/* <span
                className="badge bg-warning rounded-pill"
                style={{ fontSize: "12px", top: "0px" }}
              ></span> */}
            <span
              style={{
                fontSize: "12px",
                position: "absolute",
                top: "-6px",
                // right: "",
              }}
              className="badge bg-warning rounded-pill"
            >
              {!isEmpty(uploadInput) ? uploadInput.length : 0}
            </span>
            {/* <input
              type="file"
              accept="application/pdf, audio/mp3 , image/jpeg"
              id="upload-btn"
              multiple
              onChange={(e) => uploadPaymentVoice(e)}
              className={salesList ? "disabled-button" : ""}
              disabled={salesList === true ? true : false}
              hidden
            /> */}
            {/* <div
              className="btn header-item noti-icon"
              onClick={() => uploadInvoice()}
            >
              <label
                htmlFor="upload-btn"
                className={
                  salesList ? "upload-file disabled-button" : "upload-file"
                }
              >
                <IoAttachOutline
                  style={{ fontSize: "20px", fontWeight: "500" }}
                />{" "}
                Payment Terms Voice
              </label>
              <span
                className="badge bg-warning rounded-pill"
                style={{ fontSize: "12px", top: "0px" }}
              >
                {uploadClick ? uploadInput : 0}
              </span>
            </div> */}
          </Col>
          {/* Transaction section */}
          <Col
            md="12"
            xl="12"
            lg="12"
            sm="12"
            xs="12"
            className="mb-2 mt-2 quote-head-content"
          >
            <p className="quote-head ms-1">
              Transaction
              <span className="quote-info">
                <i
                  style={{ color: "grey" }}
                  id="transactionInfo"
                  aria-hidden="true"
                  className="fa fa-info-circle ms-1"
                ></i>
                <UncontrolledTooltip placement="right" target="transactionInfo">
                  Transaction Description
                </UncontrolledTooltip>
              </span>
            </p>
          </Col>
          <Col
            md="12"
            xl="12"
            lg="12"
            sm="12"
            xs="12"
            className="d-flex flex-row"
          >
            <div
              onClick={() => {
                setChecked(!checked)
                setWithoutAdvance(false)
                setAdvance("1")
              }}
              className={salesList ? "disabled-button" : "transaction-check"}
              id="1"
            >
              <Input
                type="checkbox"
                id="withInvoice"
                checked={checked === true ? false : true}
                disabled={salesList ? true : false}
                style={{ fontSize: "18px", color: "#aaa9aa" }}
              />
              <label
                htmlFor="withInvoice"
                style={{
                  fontSize: "16px",
                  color: "#495057",
                  margin: "4px",
                }}
                disabled={salesList ? true : false}
              >
                Proceed With Advance
              </label>
            </div>
            <div
              onClick={() => {
                setChecked(true)
                setWithoutAdvance(true)
                setAdvance("2")
              }}
              className={
                salesList ? "disabled-button" : "mx-3 transaction-check"
              }
              id="2"
            >
              <Input
                type="checkbox"
                id="withoutInvoice"
                style={{
                  fontSize: "18px",
                  color: "#aaa9aa",
                  marginTop: "5px",
                }}
                checked={checked === true ? true : false}
                disabled={salesList ? true : false}
              />
              <label
                htmlFor="withoutInvoice"
                style={{ fontSize: "16px", color: "#495057", margin: "4px" }}
                disabled={salesList ? true : false}
              >
                Proceed Without Advance
              </label>
            </div>
          </Col>
          {/* Transaction Table Section */}
          <Col md="12" lg="12" xl="12" className="mt-3">
            {withoutAdvance ? (
              ""
            ) : (
              <Table bordered className="data-table-border">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Payment Mode</th>
                    <th>Attachment</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(transactionData)
                    ? transactionData.map((data, index) => {
                      console.log("datavaluegrid", data)
                      return (
                        <tr className="bg-white" key={index}>
                          <td style={{ width: "10%" }}>
                            <Input
                              type="date"
                              name="date"
                              value={data && data.date ? data.date : ""}
                              disabled={
                                (paymentTerms &&
                                  paymentTerms.value === advancePaymentId) ||
                                  salesList
                                  ? true
                                  : false
                              }
                              onChange={(e) => transactionChange(e, index)}
                              placeholder="Select Date"
                            />
                          </td>
                          <td style={{ width: "20%" }}>
                            <Input
                              type="text"
                              name="amount"
                              value={
                                data && data.amount
                                  ? // data.amount <= totalPayableValue

                                  data.amount
                                  : ""
                              }
                              disabled={
                                (paymentTerms &&
                                  paymentTerms.value === advancePaymentId) ||
                                  salesList
                                  ? true
                                  : false
                              }
                              onChange={(e) => transactionChange(e, index)}
                              placeholder="Enter Amount"
                            />
                          </td>
                          <td style={{ width: "30%" }}>
                            <Select
                              name="paymentMode"
                              options={
                                salesMetaData
                                  ? salesMetaData.paymentModeOptions
                                  : []
                              }
                              value={
                                data && data.paymentMode
                                  ? data.paymentMode
                                  : []
                              }
                              isDisabled={salesList ? true : false}
                              onChange={(e) => paymentModeChange(e, index)}
                              placeholder="Select Payment Mode"
                            />

                            {data && data.paymentMode.mode === 1 ? (
                              <>
                                <Select
                                  name="account"
                                  type="autocomplete"
                                  value={
                                    data && data.account ? data.account : ""
                                  }
                                  noOptionsMessage={() => null}
                                  // isSearchable={true}
                                  isClearable
                                  closeMenuOnSelect={true}
                                  styles={style}
                                  onChange={(e) => accountChange(e, index)}
                                  options={bankOptions}
                                  isDisabled={
                                    salesList === true ? true : false
                                  }
                                  className="mt-1"
                                  placeholder="Select Bank Details"
                                />
                              </>
                            ) : (
                              ""
                            )}
                          </td>
                          <td style={{ width: "20%" }}>
                            <div
                              // className="file btn btn-info"
                              style={{
                                overflow: "hidden",
                                position: "relative",
                              }}
                              className={
                                salesList
                                  ? "file btn btn-info disabled-button"
                                  : "file btn btn-info"
                              }
                              disabled={salesList === true ? true : false}
                            >
                              <i
                                className="fas fa-paperclip"
                                style={{ marginRight: "5px" }}
                              ></i>
                              Upload
                              <Input
                                type="file"
                                name="uploadInput"
                                accept="application/pdf, audio/mp3 , image/jpeg"
                                // id="upload-btn"
                                multiple
                                onChange={(e) => uploadTransactionFile(e)}
                                style={{
                                  position: "absolute",
                                  fontSize: "50px",
                                  opacity: 0,
                                  right: 0,
                                  top: 0,
                                }}
                              />
                            </div>
                            {/* <span
                className="badge bg-warning rounded-pill"
                style={{ fontSize: "12px", top: "0px" }}
              ></span> */}
                            <span
                              style={{
                                fontSize: "12px",
                                position: "absolute",
                                top: "49px",
                                // right: "37px",
                              }}
                              className=" badge bg-warning rounded-pill"
                            >
                              {!isEmpty(transactionUpload)
                                ? transactionUpload.length
                                : 0}
                            </span>
                            {/* <input
                                type="file"
                                accept="application/pdf, audio/mp3 , image/jpeg"
                                id="upload-btn1"
                                onChange={(e) => uploadTransactionFile(e)}
                                className={salesList ? "disabled-button" : ""}
                                disabled={salesList === true ? true : false}
                                multiple
                                hidden
                              /> */}
                            {/* <div
                                className="btn header-item noti-icon"
                                onClick={() => transactionInvoice()}
                              >
                                <label
                                  htmlFor="upload-btn1"
                                  className={
                                    salesList
                                      ? "upload-file d-flex flex-row disabled-button"
                                      : "upload-file d-flex flex-row"
                                  }
                                >
                                  <IoAttachOutline
                                    style={{
                                      fontSize: "20px",
                                      fontWeight: "500",
                                    }}
                                  />{" "}
                                  Upload
                                </label>
                                <span
                                  className="badge bg-warning rounded-pill"
                                  style={{ fontSize: "12px", top: "0px" }}
                                >
                                  {transactionClick ? transactionUpload : 0}
                                </span>
                              </div> */}
                          </td>
                          <td style={{ width: "20%" }}>
                            <Input
                              type="text"
                              name="remarks"
                              value={data && data.remarks ? data.remarks : ""}
                              onChange={(e) => transactionChange(e, index)}
                              placeholder="Enter Remarks"
                              disabled={salesList === true ? true : ""}
                            />
                          </td>
                        </tr>
                      )
                    })
                    : []}
                </tbody>
              </Table>
            )}
          </Col>
          <Col md="12" xl="12" lg="12" className="event-details-submit mt-3">
            {salesList ? (
              ""
            ) : // (salesManagerId === "6394779685898637927c8f5b" &&
              //     sales_list.length > 0) ||
              (salesManagerId === "6394779685898637927c8f5b" &&
                !isEmpty(sales_list)) ||
                isSalesEdit ? (
                <>
                  <button
                    onClick={() => {
                      setListShow(false)
                    }}
                    type="button"
                    className="btn btn-danger btn-label form-cancel-btn"
                  >
                    <i className="bx bx-block label-icon "></i>
                    Cancel
                  </button>
                  <button
                    type="submit"
                    onClick={() => {
                      setListShow(false)
                      updateSalesDetails()
                    }}
                    disabled={
                      !isEmpty(eventDetailsData) && eventDetailsData.length > 0
                        ? true
                        : false
                    }
                    className="btn btn-success btn-label form-submit-btn"
                  >
                    <i className="bx bx-check-double label-icon"></i>
                    Update
                  </button>
                </>
              ) : (
                <>
                  {" "}
                  <button
                    onClick={() => {
                      setListShow(false)
                    }}
                    type="button"
                    className="btn btn-danger btn-label form-cancel-btn"
                  >
                    <i className="bx bx-block label-icon "></i>
                    Cancel
                  </button>
                  <button
                    type="submit"
                    onClick={() => {
                      setSalesConfirmModal(true)
                    }}
                    disabled={
                      salesList === true ||
                        (!isEmpty(eventDetailsData) && eventDetailsData.length > 0)
                        ? true
                        : false
                    }
                    className="btn btn-success btn-label form-submit-btn"
                  >
                    <i className="bx bx-check-double label-icon"></i>
                    Submit
                  </button>
                </>
              )}
          </Col>
          {salesConfirmModal && (
            <Modal show={salesConfirmModal} onHide={handleSalesModal}>
              <Modal.Header
                style={{
                  fontWeight: 600,
                  backgroundColor: "#e83e8c",
                  fontSize: "16px",
                  color: "#ffffff",
                }}
              >
                Confirm Sales
              </Modal.Header>
              <Modal.Body>
                Are you sure, you want to submit the sales ?
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={handleSalesModal}
                >
                  Close
                </Button>
                {/* <Link to={"/sales-approval"}> */}
                <Button
                  variant="primary"
                  className="btn btn-success"
                  onClick={() => {
                    handleSales()
                    handleSalesModal()
                    setSalesList(true)
                    // setListShow(true)
                  }}
                >
                  Confirm
                </Button>
                {/* </Link> */}
              </Modal.Footer>
            </Modal>
          )}
          {clientTypeModal && (
            <Modal size="md" show={clientTypeModal}>
              <Modal.Header
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Client Type
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col cm="12" md="12" lg="12" className="mt-3 mb-3">
                    <div className="d-flex justify-content-between">
                      <Label className={"form-label"}>{"Lead Quotation Range"} <span className="required"> *</span></Label>
                    </div>
                    <Select
                      type="text"
                      name="quotationRange"
                      value={quotationRange}
                      // isMulti
                      onChange={(e) => setQuotationRange(e)}
                      options={
                        [{ label: "Green", value: "Green" },
                        { label: "Blue", value: "Blue" },
                        { label: "Orange", value: "Orange" },
                        ]
                      }
                      placeholder="Select Lead Quotaion range"
                      classNamePrefix="select2-selection"
                    />
                    <div
                      style={{ textTransform: "capitalize" }}
                    >
                      {simpleEscalationValidator.current.message(
                        "Lead Quotation Range",
                        quotationRange,
                        "required"
                      )}
                    </div>
                  </Col>
                </Row>
              </Modal.Body>

              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={() => setClientTypeModal(false)}
                >
                  No
                </Button>
                <Button
                  variant="secondary"
                  className="btn btn-success"
                  data-bs-dismiss="modal"
                  onClick={() => updateClientType()}
                >
                  Yes
                </Button>
              </Modal.Footer>
            </Modal>
          )}
        </>
      </Row>
    </React.Fragment>
  )
}

Sales.propTypes = {
  dispatch: PropTypes.func,
  record_client_details: PropTypes.array,
  record_event_details: PropTypes.array,
  clientProfile: PropTypes.array,
  service_total_account: PropTypes.array,
  sales_list: PropTypes.array,
  sales_payment_list: PropTypes.array,
  bank_details: PropTypes.array,
  salesMetaData: PropTypes.object,
  records: PropTypes.array,
  error: PropTypes.any,
  clientId: PropTypes.any,
  access: PropTypes.array,
  location: PropTypes.array,
  metaData: PropTypes.object,
  loading: PropTypes.any,
  success: PropTypes.any,
}

const mapStateToProps = (state) => ({
  clientProps: state.client.record_client_details,
  eventProps: state.Event.record_event_details,
})

/**
 *
 * @param {function} dispatch
 * @returns
 */
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Sales))
